(function () {
  if (window.productRecommendationsSwiperReady) {
    window.initProductRecommendationsSwiper?.();
    return;
  }

  window.productRecommendationsSwiperReady = true;

  function getSlidesPerView(value, fallback) {
    const parsed = Number.parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : Math.max(parsed, 1);
  }

  function initProductRecommendationsSwiper(root = document) {
    if (!window.Swiper) {
      console.warn('[Product Recommendations] Swiper not loaded');
      return false;
    }

    const containers = [
      ...(root.matches?.('[data-product-recommendations-swiper]')
        ? [root]
        : []),
      ...root.querySelectorAll(
        '[data-product-recommendations-swiper]'
      ),
    ];

    if (!containers.length) {
      return false;
    }

    containers.forEach((container) => {
      const slider = container.querySelector(
        '.resource-list-swiper__instance'
      );

      if (!slider || slider.swiper) return;

      const slidesPerView = getSlidesPerView(
        container.dataset.slidesPerView,
        4
      );

      const mobileSlidesPerView = getSlidesPerView(
        container.dataset.mobileSlidesPerView,
        2
      );

      const tabletSlidesPerView = Math.min(
        Math.max(mobileSlidesPerView + 1, 2),
        slidesPerView
      );

      const spaceBetween = getSlidesPerView(
        container.dataset.spaceBetween,
        16
      );

      const nextEl = container.querySelector('[data-swiper-next]');
      const prevEl = container.querySelector('[data-swiper-prev]');

      new window.Swiper(slider, {
        slidesPerView: mobileSlidesPerView,
        spaceBetween,
        speed: 500,
        watchOverflow: true,

        navigation:
          nextEl && prevEl
            ? {
                nextEl,
                prevEl,
              }
            : false,

        breakpoints: {
          
          0: {
            slidesPerView: 1.5,
          },
          // 750px - 989px: 3 items
          750: {
            slidesPerView: 2.5,
          },

          // 990px - 1198px: 4 items
          990: {
            slidesPerView: 3.5,
          },

          // >= 1199px: 5 items
          1199: {
            slidesPerView: 4.5,
          },
        },
      });
    });

    return true;
  }

  function scheduleInit(root = document, attempt = 0) {
    if (initProductRecommendationsSwiper(root) || attempt >= 20) {
      return;
    }

    window.setTimeout(() => {
      scheduleInit(root, attempt + 1);
    }, 1000);
  }

  window.initProductRecommendationsSwiper =
    initProductRecommendationsSwiper;

  document.addEventListener('DOMContentLoaded', () => {
    scheduleInit();
  });

  document.addEventListener('shopify:section:load', (event) => {
    scheduleInit(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldInit = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(
            '[data-product-recommendations-swiper]'
          ) ||
            node.querySelector?.(
              '[data-product-recommendations-swiper]'
            ))
      )
    );

    if (shouldInit) {
      window.requestAnimationFrame(() => {
        scheduleInit();
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  scheduleInit();
})();